import React, { useState } from 'react';
import InputMask from 'react-input-mask';

const MaskedInput = ({
  name,
  label,
  value,
  mask,
  form,
  handleBarCodeChange,
  onChange
}) => {
  const [isFocused, setIsFocused] = useState(!!value);

  function handleChange(value) {
    onChange(value);

    const fmtBarcode = value.replace(/[\s.]/g, '');
    handleBarCodeChange(fmtBarcode);
  }

  function handleBlur() {
    if (!value) setIsFocused(false);

    form.validateFields([name]);
}

  return (
    <div className={`vert-input-container ${isFocused ? "focused" : ""}`}>
        <label className="vert-input-label">{label}</label>
        <InputMask
          className="ant-input ant-input-outlined vert-input vert-shape-default vert-template-marketplace ant-input-size-default padding-x-undefined"
          mask={mask}
          maskChar={null}
          value={value}
          onFocus={() => setIsFocused(true)}
          onChange={(e) => handleChange(e.target.value)}
          onBlur={handleBlur}
        />
    </div>
  );
}

export default MaskedInput;